import React from 'react';
import './SkeletonLoaderHeroMentors.css'; // Custom CSS for skeleton loader styles

const SkeletonLoaderHeroMentors = () => {
  return (
    <>
      {/* Skeleton for HeroWrap */}
      <section className="hero-wrap-skeleton style1">
        <div className="container">
          <div className="hero-section">
            <div className="row" style={{ marginBottom: 80 }}>
              {/* Left Section - Text */}
              <div className="col-lg-7 col-md-7 col-sm-7 headi home-slide-text">
                <div className="skeleton-title" />
                <div className="skeleton-paragraph" />
                <div className="skeleton-paragraph short" />
                <div className="skeleton-paragraph short mt-2" />
                <div className="skeleton-button mt-3" />
              </div>
              {/* Right Section - Image */}
              <div className="col-lg-5 col-md-5 col-sm-5 headi">
                <div className="skeleton-image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Skeleton for Mentors */}
      <section className="mentors-skeleton">
        <div className="heading-skeleton" style={{ marginTop: 0 }}>
          <div className="skeleton-heading-icon" />
          <div className="skeleton-heading-text" />
          <div className="skeleton-heading-icon" />
        </div>
        <div className="container" style={{ marginBottom: 80 }}>
          <div className="content-skeleton">
            <div className="row">
              {/* Left Sidebar Skeleton */}
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="skeleton-sidebar">
                  <div className="skeleton-card" />
                  <div className="skeleton-card" />
                </div>
              </div>
              {/* Tutors List Skeleton */}
              <div className="col-lg-8 col-md-8 col-sm-12">
                {Array.from({ length: 3 }).map((_, index) => (
                  <div key={index} className="skeleton-card" />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SkeletonLoaderHeroMentors;
